/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type ConversationSentimentFilterConfigColumn =
  (typeof ConversationSentimentFilterConfigColumn)[keyof typeof ConversationSentimentFilterConfigColumn];

export const ConversationSentimentFilterConfigColumn = {
  conversation_sentiment: 'conversation_sentiment',
} as const;
